<template>
	<transition name="fade">
		<div id="new-form" class="modal-box" v-if="config.show" >
			<div class="modal modal-sm p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">새 문자 양식 작성하기</h2>
					<a href="#none" class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
					</div>
				</div>
				<div class="modal-body p-15" style="min-height: 1px;">
					<div class="send-box full-width">
						<div class="sms-box">
							<div class="sms-text-box m-b-5">
								<!-- <div class="round on-border p-5 bg-white">
									<input v-model="title"
                                    class="form-control m-b-0 no-border text-left"
                                    type="text"
                                    maxlength="20"
                                    placeholder="제목을 입력하세요.">
								</div> -->
								<textarea :maxlength="content_max" class="m-t-10" cols="30" v-model="content" rows="14"></textarea>
								<span class="limit-text clearfix">
									<span class="pull-right">
										{{content.length}}/{{content_max}}<br>sms
									</span>
								</span>
							</div>
							<!-- //end .sms-text-box -->
						</div>
					</div>
				</div>
				<!-- //end .modal-body -->

				<div class="modal-footer p-15 text-center clearfix">
					<button @click="regSmsForm()" class="btn full-width bg-deepblue text-white round" type="button">저장하기</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import server from '../statics/server'// eslint-disable-line no-unused-vars
import _ from 'lodash'// eslint-disable-line no-unused-vars
import moment from 'moment'// eslint-disable-line no-unused-vars

export default {
	name:"ModalSmSFormRegister",

	components: {
	},

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	},

	data(){
		return {
			title : '',
            content : '',
            content_max : 50
		}
	},
	methods: {
		regSmsForm(){
			const self = this;
			let sms_form = {
				title : this.title,
				content : this.content,
				shareEnabled : 0,
				// atchFileId : 0,
				mberId : '',
			}

			server.putAxios('sys/smsTempl', sms_form, ({data, err}) => {
				err; data;
				self.$emit('close');
				self.$emit('refresh');
			});
		},
	},
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>